import { render, staticRenderFns } from "./s-rightmenu.vue?vue&type=template&id=388c3fb1&"
import script from "./s-rightmenu.vue?vue&type=script&lang=js&"
export * from "./s-rightmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports